import { useContext, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ThirdPartyConnectionDetailsService from '../../shared-services/third-party-connection-details/third-party-connection.service'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import logoQuickbooks from "../../../../assets/images/quickbook.png";
import logoSage from "../../../../assets/images/sage.png";
import logoXero from "../../../../assets/images/xero.png";
import { CloudProviderLogo } from '../../cloud-components/cloud-provider-logo';
import gaiaTheme from '../../../../root-components/theme';
import { BackButtonLink } from '../../../../components/presentation-components/display-elements-components/back-button-link';
import { LoadingSpinner } from '../../../../components/presentation-components/display-elements-components/loading-spinner';

export const ThirdPartyConnectionsLandingPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const thirdPartyConnectionDetailsService = new ThirdPartyConnectionDetailsService();
  const userNotificationsContext = useContext(UserNotificationsContext);
  const [searchParams, setSearchParams] = useSearchParams()
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  useEffect(() => {
    if (id === 'quickbooks') {
      if (searchParams.has('code') && searchParams.has('realmId')) {
        const code = searchParams.get('code')
        const realmId = searchParams.get('realmId')
        if (code && realmId) {
          submitCode(code, realmId)
        }
      } else if (searchParams.has('error')) {
        handleError()
      }
    } else if (id === 'sage' || id === 'xero' || id === 'sage200' || id === 'azure-carbon') {
      if (searchParams.has('code')) {
        const code = searchParams.get('code')
        if (code) {
          submitCode(code)
        }
      } else if (searchParams.has('error')) {
        handleError()
      }
    } else {
      handleError()
    }
  }, [])

  const handleError = () => {
    userNotificationsContext.openDialog({
      active: true,
      title: 'Error',
      message: `There has been an error connecting to this provider. Please visit the integrations page and try again.`,
      buttonCopy: 'Ok',
      hideCancelButton: true
    })
      .then(() => {
        navigate(`/settings/integrations`)
      })
  }

  const submitCode = (code: string, realmId?: string) => {
    if (id) {
      const details = {
        provider: id,
        code: code,
        realmId: realmId ? realmId : null
      }
      thirdPartyConnectionDetailsService.exchangeCodeForToken(details)
        .then(() => {
          navigate(`/settings/integrations/${id}`)
        })
        .catch(err => {
          console.log(err)
          handleError()
        })
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: isMobileMode ? 2 : 4, pb: isMobileMode ? 2 : 6, pl: isMobileMode ? 2 : 6, pr: isMobileMode ? 2 : 6, mt: isMobileMode ? 5 : 0 }}>
      <Stack display='flex' justifyContent='flex-start' sx={{ mb: 4 }}>
        <BackButtonLink buttonText={'Back to integrations'} link={'/settings/integrations'} />
        <Stack display='flex' direction='row' justifyContent='space-between' alignItems='center' sx={{ mt: 1 }}>
          <Stack display='flex' alignItems='center' direction='row' gap={2}>
            {id === 'quickbooks' && <>
              <img src={logoQuickbooks} alt="quickbooks logo" width='100rem' />
              <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Quickbooks</Typography>
            </>}
            {id === 'sage' && <>
              <img src={logoSage} alt="sage logo" width='100rem' />
              <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Sage Accounting</Typography>
            </>}
            {id === 'sage200' && <>
              <img src={logoSage} alt="sage logo" width='100rem' />
              <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Sage 200 Standard</Typography>
            </>}
            {id === 'xero' && <>
              <img src={logoXero} alt="xero logo" width='100rem' />
              <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Xero</Typography>
            </>}
            {id === 'azure-carbon' && <>
              <CloudProviderLogo provider='azure-carbon' size={48} />
              <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Carbon optimization in Azure</Typography>
            </>}
          </Stack>
        </Stack>
      </Stack>
      <LoadingSpinner />
    </Box >
  )
}